import { useEffect } from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { ALL_MISSIONS } from '@bloomays-lib/adapter.api-bloomer';
import { WithErrorBoundary } from '@bloomays-lib/ui.shared';
import { AllMissionGQLItemResult } from '@bloomays-lib/types.shared';

import MissionsDashboard from '../organisms/MissionsDashboard';
import { notify } from '../../helpers/toastify';
import { errorLogger } from '../../helpers/error';

/**
 * Dashboard des missions freelance (équipe interne / Bloomies) — route /missions-freelance.
 *
 * Cette page se charge uniquement de récupérer les données : toutes les missions
 * signées sont chargées (sans filtre isActive), puis l'organisme MissionsDashboard
 * calcule KPIs, filtres et onglets côté front à partir de ce dataset (TEC-3032).
 */
const FreelanceMissionsDashboard = () => {
  const {
    error: errorMissions,
    data: dataMissions,
    loading: loadingMissions,
  } = useQuery<{
    allMissions: { results: AllMissionGQLItemResult[] };
  }>(ALL_MISSIONS);

  const notifyError = (e: ApolloError) => {
    errorLogger(e, {
      extraInfos: 'Internal server error, impossible to retrieve data about bloomers and their infos !',
    });
    notify('error', e.message, e);
  };

  useEffect(() => {
    if (!errorMissions) return;
    notifyError(errorMissions);
  }, [errorMissions]);

  return <MissionsDashboard loading={loadingMissions} dataMissions={dataMissions?.allMissions?.results || []} />;
};

export default WithErrorBoundary(FreelanceMissionsDashboard);
